import { HeaderDropdown } from '@/components';
import { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { MdAccountCircle, MdUndo } from 'react-icons/md';
import { user } from '@/modules';
import { useSelector } from 'react-redux';
import { logout } from '@/utils';

import styles from './UserCenter.module.less';

export const UserCenter = () => {
  const userInfo = useSelector(user.selector.getUserInfoState);

  const { t } = useTranslation();
  const items: MenuProps['items'] = [
    {
      label: <a>{t('develop_prefix_tit_create_one_27')}</a>,
      key: 'user',
      icon: <MdAccountCircle />,
    },
    {
      label: <a>{t('develop_prefix_logout')}</a>,
      key: 'LogOut',
      icon: <MdUndo />,
    },
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'user') {
      window.open(`${process.env.REACT_APP_DSERS_USER_CENTER_HOST}`);
      return;
    }
    if (key === 'LogOut') {
      //清除redux缓存
      localStorage.removeItem('persist:root_develop');
      //清除session 跳转用户中心
      logout();
    }
  };

  const getIconPrefix = () => {
    const name = userInfo.name || 'test';
    return name.substring(0, 1);
  };

  return (
    <HeaderDropdown menu={{ items, onClick }}>
      <div className={styles.userCenter}>
        <p className={styles.userIcon}>{getIconPrefix()}</p>
        <p className={styles.userName}>{userInfo.name || 'test'}</p>
        <span className={styles.mobileUserIcon}>
          <span className="material-symbols-rounded">arrow_drop_down</span>
        </span>
      </div>
    </HeaderDropdown>
  );
};
